<template>

  <div class="box d-flex align-items-center justify-content-center flex-column p-5 rounded-custom w-100"
       :class="{'create-bridge-style': $props.bridgeStyle, 'is-disabled': isUploadDisabled && ! $props.bridgeStyle }">

    <template v-if="$props.bridgeStyle">
      <h2>Stai creando un ponte?</h2>
      <p>Seleziona tutti gli elemneti che formano il ponte</p>
      <div class="d-flex">
        <button type="button" class="btn btn-violet text-uppercase mt-4 me-2" @click="confirm()">Crea ponte</button>
        <button type="button" class="btn btn-outline-violet text-uppercase mt-4" @click="decline()">annulla</button>
      </div>
    </template>

    <template v-else>
      <h2 v-if="$props.title !== null">{{ $props.title }}</h2>
      <p v-if="$props.subtitle !== null">{{ $props.subtitle }}</p>

      <small v-if="disabledReason" class="text-danger fw-bold mb-2">{{ disabledReason }}</small>

      <div class="mb-3">
        <label for="formFile" class="form-label"></label>
        <input @change="uploadFile($event)"
               :disabled="isUploadDisabled"
               class="form-control" type="file" id="formFile">
      </div>

    </template>

  </div>

</template>

<script>
import {computed, inject, ref, toRaw} from 'vue';
import {useRoute} from "vue-router";
import {create as createAsset} from "@/use/repositories/assets/create";
import _head from "lodash/head";

export default {
  name: "DragAndDropArea",
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    bridgeStyle: {
      type: Boolean,
      default: false
    },
    upload: {
      type: Array,
      required: true
    },
    model: {
      type: Array,
    },
    material: {
      type: [String, null, Object],
      required: true
    },
    isMatte: {
      type: Boolean,
    },
    colorId: {
      type: [Number, null],
      required: true
    }
  },
  emits: [
    'createBridge',
    'assetIdCreated',
    'resetSelection',
    'sync-models',
  ],
  setup(props, {emit}) {
    const route = useRoute();
    const idsToUpload = ref([]);
    let assetType = null;
    const { assetsType } = inject("constants");

    const isModelFlow = computed(() => props.model?.length === 1);

    const hasNoSelection = computed(
      () => props.upload.length === 0 && (props.model?.length ?? 0) === 0
    );

    const missingMaterial = computed(
      () => ! isModelFlow.value && ! props.material?.slug
    );

    const missingColor = computed(() => props.colorId === null);

    const isUploadDisabled = computed(
      () => hasNoSelection.value || missingMaterial.value || missingColor.value
    );

    const disabledReason = computed(() => {
      if (hasNoSelection.value) return null;
      if (missingMaterial.value && missingColor.value) {
        return "Seleziona materiale e colore prima di caricare il file";
      }
      if (missingMaterial.value) return "Seleziona il materiale prima di caricare il file";
      if (missingColor.value) return "Seleziona il colore prima di caricare il file";
      return null;
    });


    // Upload stl file.
    const uploadFile = async (e) => {
      let file = null;
      let material = null;
      let data = {
        ids: null,
        asset: null
      }

      // Fetch file
      file = e.target.files[0];

      // Read type slug.
      if (props.model.length === 1) {
        assetType = _head(props.model).type;
        material = _head(props.model).material;
      } else {
        assetType = assetsType.MILLING;
        material = props.material;
      }

      //Read ids and create assets.
      createAsset(
        route.params.test_work_queue_phases_id,
        toRaw(props.upload),
        file,
        material.id,
        props.colorId,
        assetType,
        props.isMatte,
      ).then((response) => {
        // Set response.
        data.ids = toRaw(props.upload);
        data.asset = response.asset;

        // Emits.
        emit('assetIdCreated', data);
        emit('resetSelection', []);

        // Sync models to upload.
        if (assetType !== "milling") {
          emit('sync-models', {
            'type': _head(props.model).type,
            'slug': _head(props.model).slug,
            'asset': response.asset,
          });
        }

        // Reset.
        document.getElementById("formFile").value = null;

      }).catch(() => {
        // Reset.
        document.getElementById("formFile").value = null;

        emit('resetSelection', []);
        emit('assetIdCreated', []);
      });
    }

    const confirm = () => {
      emit('createBridge', true);
    }
    const decline = () => {
      emit('createBridge', false);
    }

    return {
      confirm,
      decline,
      idsToUpload,
      uploadFile,
      isUploadDisabled,
      disabledReason,
    }
  }
}
</script>

<style scoped>
  .box {
    border: 5px dashed #CCCCCC;
    height: 300px;
  }
  .create-bridge-style {
    border: unset;
    background-color: #F3E9FF;
  }
  .is-disabled {
    opacity: 0.6;
    background-color: #F8F8F8;
  }
  .is-disabled :deep(input[type="file"]) {
    cursor: not-allowed;
  }
</style>
